import React, { useEffect, useState } from "react";

import { mediaRelationApi, blogApi } from "../redux";
import { connect } from "react-redux";
import { imgUrl } from "../redux/config";

import { Breadcrumb, Container, Button, Row, Col } from "react-bootstrap";
import banner from "../assets/images/media_banner.png";
import aboutBannerLogo from "../assets/images/mediaicon.png";
import fbLogo from "../assets/images/facebook-logo.png";
import linkedInLogo from "../assets/images/linkedIn-logo.png";
import Slider from "react-slick";

import BlogCard from "../common/blogCard";
import BlogCardML from "../common/blogCardML";
import Iframe from "react-iframe";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const settings = {
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrow: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};

let IsData = false;

let id = 1;
const Media = ({ mediaRelationApi, media, blogApi, blog }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const location = useLocation();
  const category = [
    { id: 1, category: t("media.Press_Releases") },
    { id: 3, category: t("media.Authored_Artices") },
    { id: 2, category: t("media.Key_Interviews") },
    { id: 4, category: t("media.Blogs") },
    { id: 5, category: t("media.newsletter") },
  ];
  if (!IsData) {
    var x = location.pathname.split("/");
    id = x[2] === "blog" ? 4 : 1;
  }

  useEffect(() => {
    if (id === 1) {
      mediaRelationApi(1, "", "");
    } else {
      blogApi();
    }
  }, [blogApi, mediaRelationApi]);

  if (Object.keys(media).length) {
    IsData = true;
    const mediaData = { ...media.data };
    var mediaList = JSON.parse(mediaData.media);
    if (Array.isArray(mediaList)) {
      mediaList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }
  }
  if (Object.keys(blog).length && id === 4) {
    IsData = true;
    const blogData = { ...blog.data };
    let blogs = blogData.Blogs || [];
    if (lang === "hindi") {
      mediaList = blogs.filter((item) => item.blog_title_hin);
    } else if (lang === "gujarati") {
      mediaList = blogs.filter((item) => item.blog_title_guj);
    } else if (lang === "marathi") {
      mediaList = blogs.filter((item) => item.blog_title_mar);
    } else {
      mediaList = blogs;
    }
  }
  const setCategory = (item) => {
    id = item.id;
    if (id <= 3) {
      mediaRelationApi(item.id, "", "");
    }
    if (id == 5) {
      mediaRelationApi(item.id, "", "");
    } else {
      blogApi();
    }
  };
  return (
    <div className="media inner_page">
      <div className="banner text-center position-relative">
        <img className="img_round" src={banner} alt="" />
        <article className="position-absolute text-center">
          <span className="d-flex justify-content-center align-items-center mx-auto">
            <img src={aboutBannerLogo} alt="" />
          </span>
          <h1 className="text-uppercase">{t("media.title")}</h1>
        </article>
        <div className="breadouter">
          <div className="container">
            <Breadcrumb className="mb-0 py-2">
              <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
              <Breadcrumb.Item active>{t("media.title")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      {(IsData && (
        <section>
          <Container>
            <div className="text-center">
              {category.map((data, i) => {
                return (
                  <Button
                    key={i}
                    variant="success"
                    className={id === data.id ? "btn_lg active" : "btn_lg"}
                    onClick={() => setCategory(data)}
                  >
                    {data.category}
                  </Button>
                );
              })}
              <Button

                variant="success"
                className={"btn_lg"}
                //navigate to url
                onClick={() => window.location.href = "/knowledge-panel"}

              >
                {t("media.knowledgepanel")}
              </Button>
            </div>

            <div
              className="blog text-center card_round wow fadeInUp"
              data-wow-delay="0.5s"
            >
              {id <= 3 ? (
                <Slider {...settings}>
                  {mediaList?.map((slide, index) => {
                    return (
                      <div
                        key={index}
                        className="wow fadeInUp"
                        data-wow-delay="0.5s"
                      >
                        <BlogCard item={slide} id={id} uri={imgUrl} />
                      </div>
                    );
                  })}
                </Slider>
              ) : (
                ""
              )}
              {/* blog  */}
              {id == 4 ? (
                <Row>
                  {mediaList?.map((slide, index) => {
                    return (
                      <Col key={index} md={4} className="bl_list">
                        <BlogCardML item={slide} id={id} uri={imgUrl} />
                        {/* <BlogCard item={slide} id={id} uri={imgUrl} /> */}
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                ""
              )}

              {id === 5 ? (
                // <Slider {...settings}>
                //     {mediaList.map((slide, index) =>{
                //         return (
                //             <div key={index} className="wow fadeInUp" data-wow-delay="0.5s">
                //                 <BlogCard item={slide} id={id} uri ={imgUrl} />
                //             </div>
                //         );
                //     })}
                // </Slider>
                <Row>
                  {mediaList?.map((slide, index) => {
                    return (
                      <Col key={index} md={4} className="bl_list">
                        <BlogCard item={slide} id={id} uri={imgUrl} />
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                ""
              )}
            </div>
          </Container>
        </section>
      )) ||
        ""}


    </div>
  );
};

const mapStatetoProps = (state) => {
  return {
    media: state.mediaR.media,
    blog: state.mediaR.blog,
  };
};
const mapDispatchtoProps = (dispatch) => {
  return {
    mediaRelationApi: function (category_id, month_id, year_id) {
      dispatch(mediaRelationApi(category_id, month_id, year_id));
    },
    blogApi: function () {
      dispatch(blogApi());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(Media);
